import { debounce, sendText } from './utils.js';

export function address() {
    const addressInputMenu = document.querySelectorAll('.__address_input__menu');
    const numberInputs = document.querySelectorAll('.__address_input__number');
    
    // Инициализация DaData для find-city-modal (только если не в order странице)
    if (!document.querySelector('#find-city-modal')) {
        initDaDataCityInput();
    }
    
    if(addressInputMenu.length === 0) return;
    addressInputMenu.forEach(menu=>{   
        console.log(menu);    
        const input = menu.querySelector('.__address_input__input');
        const list = menu.querySelector('.__address_input__list');
        
        // Если это find-city-modal, скрываем стандартные подсказки и не добавляем обработчики
        if (input.id === 'find-city-modal') {
            list.style.display = 'none';
            console.log('Скрываем стандартные подсказки для find-city-modal');
            return; // Пропускаем добавление обработчиков для этого input
        }
        
        input.addEventListener('input',()=>{
            console.log('Event create');
            if (addressInputMenu.length > 1) {
                input.form.dataset.state = 'disabled';
                numberInputs.forEach(number => {
                    number.classList.add('disabled');
                    number.value = '';
                });
            }
            console.log(input)
            console.log(list)
            console.log(menu.dataset.list)
            debouncedSendApi(input, list, menu.dataset.list);
        });
    });
    const addressInputs = document.querySelectorAll('.__address_input__number');
    addressInputs.forEach(input=>{
        input.addEventListener('input',()=>{
            addressInputs.forEach(same=>{
                if(same.name == input.name && same !== input) same.value = input.value;
            });
            debouncedPlacemarks();
        });
    });

    const privateHouseCheckboxes = document.querySelectorAll('.__private_house__checkbox');
    const privateHouseInputs = document.querySelectorAll('.__private_house__input_clear');
    if(privateHouseCheckboxes.length === 0 || privateHouseInputs.length === 0) return;
    privateHouseCheckboxes.forEach(checkbox=>{
        checkbox.addEventListener('click',()=>{
            privateHouseCheckboxes.forEach(check=>{
                check.checked = checkbox.checked;
            });
            privateHouseInputs.forEach(input=>{
                input.value = '';
                if(checkbox.checked) {
                    input.classList.add('address-disabled');
                } else {
                    input.classList.remove('address-disabled');
                };
            });
        });
    });
}

// Функция инициализации DaData для input с id find-city-modal
function initDaDataCityInput() {
    const input = document.getElementById('find-city-modal');
    if (!input) return;

    // Токен DaData
    const DADATA_TOKEN = '6d16c03eba1191a4349adef36b7f2f82685e6cb2';
    const API_URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address';

    let suggestBox;
    let suppressSuggest = false;

    function ensureSuggestBox() {
        if (suggestBox) return suggestBox;
        suggestBox = document.createElement('div');
        suggestBox.style.position = 'absolute';
        suggestBox.style.zIndex = '1000';
        suggestBox.style.background = '#fff';
        suggestBox.style.border = '1px solid #E6E6E6';
        suggestBox.style.borderRadius = '8px';
        suggestBox.style.maxHeight = '220px';
        suggestBox.style.overflowY = 'auto';
        suggestBox.style.padding = '6px 0';
        suggestBox.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)';
        suggestBox.style.display = 'none';
        
        const wrapper = input.closest('.input-label') || input.parentElement;
        wrapper.style.position = 'relative';
        wrapper.appendChild(suggestBox);
        return suggestBox;
    }

    function hideSuggest() {
        if (!suggestBox) return;
        suggestBox.style.display = 'none';
        suggestBox.innerHTML = '';
    }

    function render(items) {
        const box = ensureSuggestBox();
        box.innerHTML = '';
        if (!items.length) {
            hideSuggest();
            return;
        }
        
        items.forEach(({ city, label }) => {
            const el = document.createElement('div');
            el.textContent = label;
            el.classList.add('address-menu__info-list__item');
            el.style.padding = '8px 12px';
            el.style.cursor = 'pointer';
            el.addEventListener('mousedown', (e) => {
                e.preventDefault();
                suppressSuggest = true;
                input.value = city || label;
                input.dataset.cityValid = 'true';
                input.dataset.cityValue = city || label;
                hideSuggest();
                input.dispatchEvent(new Event('input', { bubbles: true }));
                setTimeout(() => { suppressSuggest = false; }, 250);
            });
            el.addEventListener('mouseenter', () => { el.style.background = '#F5F5F5'; });
            el.addEventListener('mouseleave', () => { el.style.background = 'transparent'; });
            box.appendChild(el);
        });
        
        box.style.left = '0px';
        box.style.right = '0px';
        box.style.top = `${(input.offsetHeight || 0) + 20}px`;
        box.style.display = 'block';
        box.style.maxHeight = '15rem';
        box.style.height = 'fit-content'
    }

    async function fetchCities(q) {
        if (!DADATA_TOKEN || q.length < 2) {
            hideSuggest();
            return;
        }
        
        const payload = {
            query: q,
            count: 10,
            from_bound: { value: 'city' },
            to_bound: { value: 'city' },
            locations: [{ country: 'Россия' }]
        };
        
        let res;
        try {
            res = await fetch(API_URL, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${DADATA_TOKEN}`
                },
                body: JSON.stringify(payload)
            });
        } catch (_) {
            res = null;
        }
        
        if (!res || !res.ok) {
            hideSuggest();
            return;
        }
        
        let data = null;
        try {
            data = await res.json();
        } catch (_) {}
        
        const items = (data?.suggestions || []).map(s => {
            const city = s.data.city || s.data.settlement || '';
            const label = s.data.city_with_type || s.data.settlement_with_type || s.value;
            
            // Убираем "г." из названия города
            const cleanLabel = label.replace(/^г\.\s*/i, '');
            const cleanCity = city.replace(/^г\.\s*/i, '');
            
            return {
                city: cleanCity,
                label: cleanLabel
            };
        }).filter(x => x.city || x.label);
        
        render(items);
    }

    const onInput = debounce((e) => {
        if (suppressSuggest) return;
        if (!e || !e.isTrusted) return;
        
        const q = input.value.trim();
        input.dataset.cityValid = 'false';
        input.dataset.cityValue = '';
        
        if (!q) {
            hideSuggest();
            return;
        }
        
        fetchCities(q);
    }, 300);

    input.addEventListener('input', (e) => onInput(e));
    input.addEventListener('blur', () => setTimeout(hideSuggest, 120));
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter') hideSuggest(); });
    document.addEventListener('click', (e) => {
        if (suggestBox && !suggestBox.contains(e.target) && e.target !== input) {
            hideSuggest();
        }
    });
}

const debouncedSendApi = debounce(sendApi, 500);
const debouncedPlacemarks = debounce(appendPlacemarks, 500);

function sendApi(input, list, attr) {
    let value = input.value;
    console.log(input)
    console.log(attr)
    if(attr == 'address') {
        const cityInputMenu = document.querySelector('.__address_input__menu[data-list="city"]');
        const cityInput = cityInputMenu.querySelector('.__address_input__input');
        if(cityInput.value !== '' && input.value !== '') value = cityInput.value + ', ' + input.value;
    };
    sendText('https://suggest-maps.yandex.ru/v1/suggest?apikey=6113898e-6805-4af0-a178-94df8a308a44', value)
    .then(async(res)=>{
        const results = res.results;

        if(!results) return;

        const fragment = document.createDocumentFragment();
        const promises = results.map(async(result)=>{
            if(attr == 'city') {
                if(!result.tags.includes('locality')) return;
                const item = await createListItem(result, attr);
                list.dataset.state = 'active';
                fragment.appendChild(item);
            } else if (attr == 'address') {
                if(!result.tags.includes('street')) return;
                if(result.subtitle && result.subtitle.text.includes(value)) return;
                const item = await createListItem(result, attr);
                list.dataset.state = 'active';
                fragment.appendChild(item);
            }
        });

        Promise.all(promises).then(()=>{
            list.innerHTML = '';
            list.appendChild(fragment);
        });
    });
}

function createListItem(data, attr) {
    
    console.log(data)
    console.log(attr);
    
    const item = document.createElement('div');
    item.classList.add('address-menu__info-list__item');
    item.innerText = `${data.title.text}`;
    
    // const inputOld = document.querySelector('#wholesalers-form-city-input')

    item.addEventListener('click',()=>{
        console.log('click')
        const menus = document.querySelectorAll(`.__address_input__menu[data-list="${attr}"]`);
        menus.forEach(menu=>{
            const input = menu.querySelector('.__address_input__input');
            const list = menu.querySelector('.__address_input__list');
            list.dataset.state="disabled";
            list.innerText = '';
            input.value = data.title.text;
        });
        if(attr == 'city') {
            const addresses = document.querySelectorAll(`.__address_input__menu[data-list="address"]`);
            addresses.forEach(menu=>{
                const input = menu.querySelector('.__address_input__input');
                input.value = '';
                input.classList.remove('disabled');
                input.form.dataset.state = 'disabled';
            });
        } else if (attr == 'address') {
            const numberInputs = document.querySelectorAll('.__address_input__number');
            numberInputs.forEach(input=>{
                input.classList.remove('disabled');
                input.form.dataset.state = 'active';
            });
        };

        appendPlacemarks();

        inputOld.value = data.title.text
    });
    return item;
}

function appendPlacemarks() {
    let address = '';
    const inputCity = document.querySelector('.__address_input__input[name="city"]');
    const inputStreet = document.querySelector('.__address_input__input[name="street"]');
    const inputHouse = document.querySelector('.__address_input__number[name="house"]');
    address = address + inputCity.value;
    address = address + ' ' + inputStreet.value;
    address = address + ' ' + inputHouse.value;

    const mapAddress = document.querySelector('#address-map');
    if(!mapAddress) return;
    let firstCoordinate = '';
    let secondCoordinate = '';
    let myGeocoder = ymaps.geocode(address)
    .then(res=>{
        firstCoordinate = res.geoObjects.get(0).geometry.getCoordinates()['0'];
        secondCoordinate = res.geoObjects.get(0).geometry.getCoordinates()['1'];

        Array.from(mapAddress.children).forEach((el) => {
            mapAddress.removeChild(el);
        });

        ymaps.ready(init);
        var myMap;

        function init() {
            myMap = new ymaps.Map("address-map", {
                center: [Number(firstCoordinate), Number(secondCoordinate)], 
                zoom: 15,
                controls: [],
            });
            setTimeout(() => {
                let placemark = new ymaps.Placemark([Number(firstCoordinate), Number(secondCoordinate)], {}, {
                    iconLayout: "default#image",
                    iconImageHref: '/static/assets/images/map-pin-active.png',
                    iconImageSize: [54, 60],
                    iconImageOffset: [-27, -30],
                });

                myMap.geoObjects.add(placemark)
            }, 50);
        }
    });
}